import React, { useEffect, useState } from "react";
import { Column, DataGrid, Format, Button } from "devextreme-react/data-grid";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { useMsal } from "@azure/msal-react";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import Container from "@material-ui/core/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../../modal.css";
import { api_path } from "../../shared.js";
const url = api_path + "/GET_SALES_ORDER_DETAILS.php";
function SaleOrderMasterDetailView(props) {
  const [GET_CARRIER_CODE, SET_CARRIER_CODE] = useState(props.CARRIER_CODE);
  const [GET_SERVICES_CONTRACT, SET_SERVICES_CONTRACT] = useState(
    props.SERVICES_CONTRACT
  );
  const [GET_BULLET_CODE, SET_BULLET_CODE] = useState(props.BULLET_CODE);
  const [GET_SCAC, SET_SCAC] = useState(props.SCAC);
  const [GET_CF_FLAG, SET_CF_FLAG] = useState("1");

  const [GET_ITEM_ID, SET_ITEM_ID] = useState("");
  const [GET_BOOKING_REF, SET_BOOKING_REF] = useState("");
  const [GET_BOOKING_NO, SET_BOOKING_NO] = useState("");
  const [GET_PROFORMA_ETD, SET_PROFORMA_ETD] = useState(null);
  const [GET_ETA, SET_ETA] = useState(null);
  const [GET_BSE_NO, SET_BSE_NO] = useState(null);
  const [GET_CTNR_CUTOFF_DATE, SET_CTNR_CUTOFF_DATE] = useState(null);
  const [GET_CTNR_CUTOFF_TIME, SET_CTNR_CUTOFF_TIME] = useState(null);
  const [GET_REMARK, SET_REMARK] = useState("");
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);
  const [GET_USER_ID, SET_USER_ID] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { instance, accounts } = useMsal();
  function fetchUserRole(userEmail) {
    fetch(api_path + "/USER_ROLE.php?USER_EMAIL=" + userEmail)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          SET_USER_ID(i.CRM_UID);
        }
      });
  }
  const orderDataSource = createStore({
    key: "ORDER_ID",
    loadUrl: `${url}`,
    loadParams: { ORDER_ID: props.ORDER_ID },
  });
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "STATUS_NAME" && e.data.ACTIVE_STATUS == 1) {
        e.cellElement.innerHTML =
          "<p style='color: GREEN;text-align:left;'>" +
          e.data.STATUS_NAME +
          "</p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.ACTIVE_STATUS == 100
      ) {
        e.cellElement.innerHTML =
          "<p style='color: GREEN;text-align:left;'>" +
          e.data.STATUS_NAME +
          "</p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.ACTIVE_STATUS > 1
      ) {
        e.cellElement.innerHTML =
          "<p style='color: RED;text-align:left;'>" +
          e.data.STATUS_NAME +
          "</p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.ACTIVE_STATUS == 0
      ) {
        e.cellElement.innerHTML =
          "<p style='color: RED;text-align:left;'>" +
          e.data.STATUS_NAME +
          "</p>";
      } else {
      }
    }
  };
  function updateConfirmStatus(ORDER_ITEM_ID, ORDER_ID, USER_ID) {
    var data = {
      ORDER_ID: ORDER_ID,
      ORDER_ITEM_ID: ORDER_ITEM_ID,
      USER_ID: USER_ID,
      REMARK: GET_REMARK,
      CF_FLAG: GET_CF_FLAG,
    };
    fetch(api_path + "/SALES_ORDER_UpdateSalesOrderConfirm.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 5000,
          }).then(function () {
            props.sendDataToParent();
            handleClose();
            const url =
              api_path +
              "/SENDMAIL_SALESORDER.php?order_id=" +
              ORDER_ID +
              "&flag=updatebooking&order_status=6";
            axios
              .get(url)
              .then((response) => {
                // handle success
                console.log(result["message"]);
              })
              .then((data) => {
                console.log(data);
                // Handle data
              })
              .catch((error) => {
                // handle errors
              });
            ////////////////////////////////////////////////////
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 5000,
          });
        }
      });
  }
  const [isCFButtonDisabled, setCFButtonDisabled] = useState(true);
  const [isUnCFButtonDisabled, setUnCFButtonDisabled] = useState(true);

  function onCFButtonClick(e) {
    SET_CF_FLAG(1);
    const dataRow = e.row && e.row.data;
    SET_ITEM_ID(dataRow.SALES_ORDER_ITEM_ID);
    SET_BOOKING_NO(dataRow.BOOKINGNO);
    SET_BOOKING_REF(dataRow.BOOKINGREF);
    SET_BSE_NO(dataRow.SMF_REFNO);
    SET_PROFORMA_ETD(dataRow.PROFORMA_ETD);
    SET_CTNR_CUTOFF_DATE(dataRow.CONTAINER_CUTOFF_DATE);
    SET_CTNR_CUTOFF_TIME(dataRow.CONTAINER_CUTOFF_TIME);
    SET_REMARK(dataRow.REMARK);
    setSelectOrderStatus(dataRow.ACTIVE_STATUS);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: dataRow.ACTIVE_STATUS,
      INQUIRY_MASTER_EN: dataRow.STATUS_NAME,
    });
    setShow(true);
  }
  function onUnCFButtonClick(e) {
    SET_CF_FLAG(0);
    const dataRow = e.row && e.row.data;
    SET_ITEM_ID(dataRow.SALES_ORDER_ITEM_ID);
    SET_BOOKING_NO(dataRow.BOOKINGNO);
    SET_BOOKING_REF(dataRow.BOOKINGREF);
    SET_BSE_NO(dataRow.SMF_REFNO);
    SET_PROFORMA_ETD(dataRow.PROFORMA_ETD);
    SET_CTNR_CUTOFF_DATE(dataRow.CONTAINER_CUTOFF_DATE);
    SET_CTNR_CUTOFF_TIME(dataRow.CONTAINER_CUTOFF_TIME);
    SET_REMARK(dataRow.REMARK);
    setSelectOrderStatus(dataRow.ACTIVE_STATUS);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: dataRow.ACTIVE_STATUS,
      INQUIRY_MASTER_EN: dataRow.STATUS_NAME,
    });
    setShow(true);
  }
  const isEdit = (BOOKINGNO) => {
    if (BOOKINGNO === "" || BOOKINGNO === null || BOOKINGNO === undefined) {
      return false;
    } else {
      return true;
    }
  };
  // 3	Reject
  // 4	Wait Carrier Release
  // 5	Wait Sales to confirm
  // 6	Sales confirm
  // 7	BSE Created
  // 8	BSE PreConfirm
  // 10	BSE Confirmed
  // 9	Cancel
  // 11	Open Job
  // if (props.ORDER_STATUS >=10) {
  //   setCFButtonDisabled(false);
  //   setUnCFButtonDisabled(false);
  // }else if (props.ORDER_STATUS == 6) {
  //   setUnCFButtonDisabled(true);
  // }else  if (props.ORDER_STATUS == 5) {
  //   setCFButtonDisabled(true);
  // }else{
  //   setCFButtonDisabled(false);
  //   setUnCFButtonDisabled(false);
  // }
  const isCFIconVisible = (e) => isEdit(e.row.data.BOOKINGNO);
  useEffect(() => {
    fetchUserRole(accounts[0]?.username);
    if (props.ORDER_STATUS == 5) {
      setCFButtonDisabled(true);
    } else {
      setCFButtonDisabled(false);
    }
    if (props.ORDER_STATUS == 6) {
      setUnCFButtonDisabled(true);
    } else {
      setUnCFButtonDisabled(false);
    }
  }, []);

  const customizeValue = (cellInfo) => {
    if (
      cellInfo.value === "" ||
      cellInfo.value === null ||
      cellInfo.value === undefined
    ) {
      return "-";
    } else {
      return cellInfo;
    }
  };
  return (
    <>
      <DataGrid
        dataSource={orderDataSource}
        showBorders={false}
        keyExpr="ORDER_ID"
        onCellPrepared={cellPrepared}
      >
        <Column dataField="SALES_ORDER_ITEM_ID" caption="ID" visible={false} />
        <Column dataField="CARRIER_CODE" caption="CARRIER" width={100} />
        <Column dataField="SERVICES_CONTRACT" caption="S/C" width={150} />
        <Column dataField="BULLET_CODE" caption="BULLET CODE" width={150} />
        <Column dataField="ACTIVE_STATUS" visible={false} />
        <Column type="buttons" caption="CONFIRM RELEASE BOOKING" width={120}>
          {isCFButtonDisabled && (
            <Button
              text="CONFIRM"
              onClick={onCFButtonClick}
              cssClass="btnLink"
              hint="Click to confirm release booking"
              visible={isCFIconVisible}
            />
          )}
          {isUnCFButtonDisabled && (
            <Button
              text="UNCONFIRM"
              onClick={onUnCFButtonClick}
              cssClass="btnLink"
              hint="Click to Unconfirm release booking"
              visible={isCFIconVisible}
            />
          )}
        </Column>
        <Column
          dataField="STATUS_NAME"
          caption="ITEM STATUS"
          cssClass="gray"
          width={200}
        />
        <Column
          dataField="REMARK"
          caption="REMARK"
          cssClass="gray"
          width={200}
        />
        <Column
          dataField="BOOKINGREF"
          caption="Book Ref"
          cssClass="gray"
          width={120}
        />
        <Column
          dataField="BOOKINGNO"
          caption="Book No."
          cssClass="gray"
          width={120}
          // customizeText={customizeText}
        />
        <Column
          dataField="PROFORMA_ETD"
          caption="PROFORMA ETD"
          cssClass="gray"
          width={120}
        />
        {/* <Column
          dataField="CONTAINER_CUTOFF_DATE"
          caption="CUTOFF DATE"
          cssClass="gray"
          width={100}
        /> */}
        <Column
          dataField="CONTAINER_CUTOFF_TIME"
          caption="CUTOFF"
          cssClass="gray"
          width={140}
        />
        <Column dataField="ETA" caption="ETA" cssClass="gray" width={120} />
        <Column
          dataField="SMF_REFNO"
          caption="SMF REFNO"
          cssClass="gray"
          width={120}
        />
      </DataGrid>
      <br />
      <table border="0" width="100%">
        <tr>
          <td width="600">
            <label className="head3">Volume</label>
            <table border="1" width="800">
              <tr className="box">
                <td width="150" colSpan="3" align="center">
                  20'
                </td>

                <td width="150" colSpan="3" align="center">
                  40'
                </td>

                <td width="150" colSpan="3" align="center">
                  40HC
                </td>

                <td width="150" colSpan="3" align="center">
                  45'
                </td>

                <td width="100" align="center">
                  GW Remark
                </td>

                <td align="center" width="120">
                  BOOK PRIORITY
                </td>

                <td align="center" width="100">
                  WAITING SALES TO CONFIRM
                </td>
              </tr>
              <tr>
                <td width="40" align="center">
                  {props.CNT20 == "0" ? "-" : props.CNT20}
                </td>
                <td width="40" align="center">
                  {props.TYPE20}
                </td>
                <td width="40" align="center">
                  {Number(props.GW20) === 0
                    ? "-"
                    : Number(props.GW20).toLocaleString()}
                </td>
                <td width="40" align="center">
                  {props.CNT40 == "0" ? "-" : props.CNT40}
                </td>
                <td width="40" align="center">
                  {props.TYPE40}
                </td>
                <td width="40" align="center">
                  {Number(props.GW40) === 0
                    ? "-"
                    : Number(props.GW40).toLocaleString()}
                </td>
                <td width="40" align="center">
                  {props.CNT40HQ == "0" ? "-" : props.CNT40HQ}
                </td>
                <td width="40" align="center">
                  {props.TYPE40HQ}
                </td>
                <td width="40" align="center">
                  {Number(props.GW40HQ) === 0
                    ? "-"
                    : Number(props.GW40HQ).toLocaleString()}
                </td>
                <td width="40" align="center">
                  {props.CNT45 == "0" ? "-" : props.CNT45}
                </td>
                <td width="40" align="center">
                  {props.TYPE45}
                </td>
                <td width="40" align="center">
                  {Number(props.GW45) === 0
                    ? "-"
                    : Number(props.GW45).toLocaleString()}
                </td>

                <td align="center">{props.GW}</td>

                <td align="center">{props.BOOK_PRIORITY}</td>
                <td align="center">
                  {props.WAITING_FLAG == "Y" ? "YES" : "NO"}
                </td>
              </tr>
            </table>
          </td>
          <td width="100">&nbsp; </td>
          <td>
            <label className="head3">Port</label>
            <table border="1" width="600">
              <tr className="box">
                <td width="80" align="center">
                  POR
                </td>

                <td width="80" align="center">
                  POL
                </td>

                <td width="80" align="center">
                  POD
                </td>

                <td width="80" align="center">
                  DEL
                </td>

                <td width="80" align="center">
                  FINAL
                </td>

                <td align="center">INLAND POSTCODE</td>
              </tr>
              <tr>
                <td width="40" align="center">
                  {props.POR == "" ? "-" : props.POR}
                </td>
                <td width="40" align="center">
                  {props.POL == "" ? "-" : props.POL}
                </td>
                <td width="40" align="center">
                  {props.POD == "" ? "-" : props.POD}
                </td>
                <td width="40" align="center">
                  {props.DEL == "" ? "-" : props.DEL}
                </td>
                <td width="40" align="center">
                  {props.FINAL == "" ? "-" : props.FINAL}
                </td>
                <td width="40" align="center">
                  {props.INLAND_POSTCODE == "" ? "-" : props.INLAND_POSTCODE}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          {GET_BOOKING_NO && GET_CF_FLAG == 1 && (
            <Modal.Title>
              Confirm to release booking : {GET_BOOKING_NO}
            </Modal.Title>
          )}
          {GET_BOOKING_NO && GET_CF_FLAG == 0 && (
            <Modal.Title>
              Unconfirm to release booking : {GET_BOOKING_NO}
            </Modal.Title>
          )}
          {!GET_BOOKING_NO && (
            <Modal.Title>Confirm to release without Booking No.</Modal.Title>
          )}
        </Modal.Header>

        <Modal.Body className="grid-example">
          <form
            onSubmit={(e) => {
              handleClose();
              e.preventDefault();
              updateConfirmStatus(GET_ITEM_ID, props.ORDER_ID, GET_USER_ID);
            }}
            id="editmodal"
            className=""
          >
            <input
              type="hidden"
              value={GET_USER_ID}
              onChange={(e) => SET_USER_ID(e.target.value)}
            />
            <input
              type="hidden"
              value={GET_ITEM_ID}
              onChange={(e) => SET_ITEM_ID(e.target.value)}
            />
            <Container>
              <Row>
                <Col xs={6} md={6}>
                  {" "}
                  &nbsp;
                </Col>
                <Col xs={6} md={6}>
                  &nbsp;
                </Col>
                <Col xs={12} md={12}>
                  <label>
                    REMARK:
                    <TextField
                      size="small"
                      name="GET_REMARK"
                      variant="outlined"
                      fullWidth
                      id="GET_REMARK"
                      value={GET_REMARK}
                      onChange={(e) => SET_REMARK(e.target.value)}
                      multiline
                      rows={2}
                      inputProps={{ maxLength: 250 }}
                    />
                    {/* <input
                      type="text"
                      value={GET_REMARK}
                      onChange={(e) => SET_REMARK(e.target.value)}
                    /> */}
                  </label>
                </Col>
              </Row>
            </Container>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function getOrderDataSource(id) {
  return {
    store: createStore({
      loadUrl: `${url}`,
      loadParams: { ORDER_ID: id },
      //   onBeforeSend: (method, ajaxOptions) => {
      //     ajaxOptions.xhrFields = { withCredentials: true };
      //   },
    }),
  };
}
export default SaleOrderMasterDetailView;
